const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const getVehicleTelemetry = async (deviceId, token) => {
  const response = await fetch(`${API}/devices/${encodeURIComponent(deviceId)}/vehicle-telemetry`, {
    credentials: "include",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    const detail = typeof payload?.detail === "string" ? payload.detail : payload?.detail?.message;
    throw new Error(detail || `Vehicle telemetry request failed: ${response.status}`);
  }
  return response.json();
};
